<section class="product-landing">
  <div class="hero">
    <div class="eyebrow">{{ product.eyebrow }}</div>
    <h1>{{ product.name }}</h1>
    <p class="tagline">{{ product.tagline }}</p>
    <p class="summary">{{ product.summary }}</p>
      <!-- <div class="hero-actions">
        <button mat-flat-button color="primary" (click)="scrollToForm()">{{ product.primaryCta }}</button>
          <button (click)="scrollToForm()" class="secondary-cta" color="primary"
                  mat-stroked-button>{{ product.secondaryCta }}
          </button>
      </div> -->
  </div>


    <div class="content-grid">
    <mat-card class="highlights">
      <h2>What you get</h2>
      <p class="supporting-copy">{{ product.supportingCopy }}</p>
      <ul>
        @for (item of product.highlights; track item) {
          <li>
              <i-tabler class="icon-16" name="key"></i-tabler>
            <span>{{ item }}</span>
          </li>
        }
      </ul>
        <div class="carousel-container">
            <app-screenshot-carousel
                    [altPrefix]="product.name"
                    [ariaLabel]="product.name + ' screenshots'"
                    [images]="product.screenshots"
            ></app-screenshot-carousel>
        </div>
    </mat-card>

    <mat-card class="form-card" #formAnchor>
      <div class="form-header">
          <div class="pill">Demo request</div>
        <h2>{{ product.formTitle }}</h2>
          <p>{{ product.formCopy }}</p>
      </div>
        <app-hubspot-form formId="1f14fc49-8476-4ef1-9162-00a1193010cc" portalId="436498"
                          region="eu1"></app-hubspot-form>
    </mat-card>
  </div>
</section>
